import type { CSSProperties, ReactNode } from "react";
import { ArrowLeft } from "lucide-react";
import { brandColors as colors } from "@/lib/palette";
import { fonts } from "@/lib/fonts";

export default function AdminFormHeader({
  title,
  eyebrow,
  backLabel,
  onBack,
  children,
}: {
  title: string;
  eyebrow?: string;
  backLabel: string;
  onBack: () => void;
  children?: ReactNode;
}) {
  return (
    <div style={styles.wrap}>
      <div style={styles.topRow}>
        <button type="button" onClick={onBack} style={styles.backButton}>
          <ArrowLeft size={15} aria-hidden="true" />
          {backLabel}
        </button>
        {children && <div style={styles.actions}>{children}</div>}
      </div>
      {eyebrow && <div style={styles.eyebrow}>{eyebrow}</div>}
      <h2 style={styles.title}>{title}</h2>
    </div>
  );
}

const styles = {
  wrap: {
    marginBottom: "1.25rem",
    paddingBottom: "1rem",
    borderBottom: "1px dashed rgba(201,147,76,0.28)",
  },
  topRow: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    gap: "1rem",
    marginBottom: "0.8rem",
  },
  backButton: {
    display: "inline-flex",
    alignItems: "center",
    gap: "0.45rem",
    border: "1px solid rgba(201,147,76,0.55)",
    borderRadius: 7,
    background: colors.cream,
    color: colors.navy,
    cursor: "pointer",
    padding: "7px 12px",
    fontFamily: fonts.body,
    fontSize: 11,
    fontWeight: 700,
    letterSpacing: "0.06em",
    textTransform: "uppercase" as const,
  },
  actions: {
    display: "flex",
    alignItems: "center",
    gap: "0.6rem",
  },
  eyebrow: {
    color: "rgba(8,45,61,0.55)",
    fontFamily: fonts.body,
    fontSize: 10,
    fontWeight: 700,
    letterSpacing: "0.16em",
    textTransform: "uppercase" as const,
    marginBottom: "0.35rem",
  },
  title: {
    color: colors.navy,
    fontFamily: fonts.logo,
    fontSize: "1.35rem",
    fontWeight: 500,
    margin: 0,
  },
} satisfies Record<string, CSSProperties>;
